import React from 'react';
import "../../assets/styles/pages/Ajuda/Docs.scss";
import img1 from "../../assets/images/faq-docs/desempatador-instrucoes-plataforma/desempatador-instrucoes-plataforma_page-0001.jpg"
import img2 from "../../assets/images/faq-docs/desempatador-instrucoes-plataforma/desempatador-instrucoes-plataforma_page-0002.jpg"
import img3 from "../../assets/images/faq-docs/desempatador-instrucoes-plataforma/desempatador-instrucoes-plataforma_page-0003.jpg"
import img4 from "../../assets/images/faq-docs/desempatador-instrucoes-plataforma/desempatador-instrucoes-plataforma_page-0004.jpg"
import img5 from "../../assets/images/faq-docs/desempatador-instrucoes-plataforma/desempatador-instrucoes-plataforma_page-0005.jpg"
import UnauthorizedPage from '../401';
import config from '../../config/config';

export default function DesempatadorManualInstrucoes() {
    document.title = 'säästo';
    return (<div className="page-docs">
        {(config.isAdmin() || config.isEspecialista()) ? <div className="doc-wrapper">
            <img src={img1} alt="Página 1" />
            <img src={img2} alt="Página 2" />
            <img src={img3} alt="Página 3" />
            <img src={img4} alt="Página 4" />
            <img src={img5} alt="Página 5" />
        </div> : <UnauthorizedPage />}
    </div>);
}